import Asset from "../../slices/maintenance/asset/Asset"
import AssetService from "../../slices/maintenance/assetService/AssetService"
import AssetInward from "../../slices/maintenance/assetInward/AssetInward"
import Schedule from "../../slices/maintenance/schedule/Schedule"
import JobCard from "../../slices/maintenance/jobCard/JobCard"
import WorkOrder from "../../slices/maintenance/workOrder/WorkOrder"

const maintenanceReducer = {
    asset: Asset,
    assetService: AssetService,
    assetInward: AssetInward,
    schedule: Schedule,
    jobCard: JobCard,
    workOrder: WorkOrder,
}

export default maintenanceReducer;